module.exports = __webpack_public_path__ + "static/AYANA-5bf1bcba66ef2feb15115aca34c7037f.jpg";